/* eslint-disable */
export const enum TaxService {
    MTD = "MTD",
    EOY_SELF_ASSESSMENT = "EOY_SELF_ASSESSMENT",
    EOY_EXPENSE_TRACKING = "EOY_EXPENSE_TRACKING",
}